import Services from '../../assets/Services.svg'
import Services1 from '../../assets/service1.svg'
import Services2 from '../../assets/service2.svg'
import Services3 from '../../assets/service3.svg'
import Services4 from '../../assets/service4.png'
export default function PharmServices () {
    return (
        <div className='mt-[2em] md:mt-[5em] max-w-[85%] mx-auto'>
            <div className='flex justify-center'>
               <img src={Services} className=' w-[15em] md:w-[20em] ' alt='Pharmtrix Services Overview Illustration'/>
            </div>
            <div className='mx-auto flex flex-col md:flex-row justify-center items-center md:items-start gap-10  mt-[2em] md:mt-[4em]'>
                <img src={Services1} alt='Pharmtrix Service Detail 1' className='w-full max-w-full h-auto object-contain md:flex-1 min-w-0'/>
                <img src={Services2} alt='Pharmtrix Service Detail 2' className='w-full max-w-full h-auto object-contain md:flex-1 min-w-0'/>  
            </div>
            <div className='mx-auto flex flex-col md:flex-row-reverse justify-center items-center md:items-start gap-10  mt-[2em] md:mt-[4em]'>
                <img src={Services4} alt='Pharmtrix Service Detail 4' className='w-full max-w-full h-auto object-contain md:flex-1 min-w-0'/>
                <img src={Services3} alt='Pharmtrix Service Detail 3' className='w-full max-w-full h-auto object-contain md:flex-1 min-w-0'/>
            </div>
            

        </div>
    )
}